import React from "react";
import { NewDocumentListView } from "../../../Shared/NewDocumentListView";
import { IListViewField } from "../../../Shared/ILIstViewField";
import { AppEntities } from "../../../../config/entities";
import { ListView } from "../../../Shared/ListViews/ListView";
import { DocumentListViewToolbar } from "../../../Shared/ListViews/DocumentListViewToolbar";
import { DocumentListViewDefaultToolbarButtons } from "../../../Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { ListviewToolbarMoreActions } from "../../../Shared/ListViews/ListviewToolbarMoreActions";

function FixedAssetsModernizationsList() {
  const fields: IListViewField[] = [];

  return (
    <>
      <ListView fields={fields} entity={AppEntities.FixedAssetsModernization} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>
    </>
  );
}

export default FixedAssetsModernizationsList;
